/*
 * Intelligent Fabric — Admin Console home page.
 *
 * Branded landing surface (the "Overview & Fleet" surface from the sketch).
 * Built from @backstage/core-components + MUI so it is resilient across
 * Backstage versions; richer fleet widgets (live KPI tiles fed by the
 * AISystem CRD + Prometheus) land as Tech Insights / custom-plugin cards
 * in Phases 30/31.
 *
 * Wired in App.tsx: <Route path="/" element={<HomepageCompositionRoot />}>.
 */
import {
  Content,
  Header,
  Page,
  InfoCard,
  ItemCardGrid,
  Link,
} from '@backstage/core-components';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';

type Tile = { label: string; value: string; delta?: string; to: string };

const KPIS: Tile[] = [
  { label: 'Agents running', value: '18 / 18', delta: '100%', to: '/catalog?filters[kind]=component' },
  { label: 'Policies enforced', value: '24', delta: '+7', to: '/policy' },
  { label: 'Audit events / 24h', value: '12.4k', to: '/observability' },
  { label: 'LLM spend / 24h', value: '$48.20', delta: '-12%', to: '/observability' },
];

const QUICK_LINKS: { title: string; desc: string; to: string }[] = [
  { title: 'Agent Factory', desc: 'Scaffold a new compliant agent → Gitea PR', to: '/create' },
  { title: 'Catalog & Inventory', desc: 'Services, agents and MCP tool APIs', to: '/catalog' },
  { title: 'Compliance', desc: 'ISO 27001 / 42001 / EU AI Act scorecards', to: '/compliance' },
  { title: 'Approvals (HITL)', desc: 'Infra-mutation actions awaiting a human', to: '/approvals' },
];

export const HomePage = () => (
  <Page themeId="home">
    <Header title="Intelligent Fabric" subtitle="Admin Console — cross-installation control plane">
    </Header>
    <Content>
      <Typography variant="h6" gutterBottom>
        Fleet overview
      </Typography>
      <Grid container spacing={3} style={{ marginBottom: 8 }}>
        {KPIS.map(k => (
          <Grid item xs={12} sm={6} md={3} key={k.label}>
            <InfoCard title={k.label} noPadding>
              <div style={{ padding: 16 }}>
                <Link to={k.to}>
                  <Typography variant="h4" style={{ fontWeight: 700 }}>
                    {k.value}
                  </Typography>
                </Link>
                {k.delta && (
                  <Typography variant="caption" color="textSecondary">
                    {k.delta}
                  </Typography>
                )}
              </div>
            </InfoCard>
          </Grid>
        ))}
      </Grid>

      <Typography variant="h6" gutterBottom style={{ marginTop: 16 }}>
        Manage
      </Typography>
      <ItemCardGrid>
        {QUICK_LINKS.map(q => (
          <InfoCard key={q.title} title={q.title}>
            <Typography variant="body2" color="textSecondary" paragraph>
              {q.desc}
            </Typography>
            <Link to={q.to}>Open →</Link>
          </InfoCard>
        ))}
      </ItemCardGrid>
    </Content>
  </Page>
);

export default HomePage;
